import React from 'react';
import PropTypes from 'prop-types';

const SECTION_GROUPS = [
    { label: "Producto", match: /datos|caracter|imagen|garant/i },
    { label: "Comercial", match: /precio|entrega|estado/i },
    { label: "Seguimiento", match: /auditor/i },
];

function groupTabs(tabs, sectionGroups) {
    const entries = (tabs || [])
        .map((tab, index) => ({ tab, index }))
        .filter(({ tab }) => tab?.name);

    const used = new Set();
    const groups = sectionGroups.map((group) => {
        const items = entries.filter(({ tab, index }) => {
            if (used.has(index) || !group.match.test(tab.name)) return false;
            used.add(index);
            return true;
        });
        return { label: group.label, items };
    }).filter((group) => group.items.length > 0);

    const rest = entries.filter(({ index }) => !used.has(index));
    if (rest.length) {
        groups.push({ label: "Otras", items: rest });
    }

    return groups;
}

export default function PubSectionNav({ tabs, activeTab, onChange, groups: sectionGroups = SECTION_GROUPS, ariaLabel = "Secciones de la publicación" }) {
    const groups = groupTabs(tabs, sectionGroups);

    return (
        <nav className="pub-editor__nav" role="tablist" aria-label={ariaLabel}>
            {groups.map((group) => (
                <div key={group.label} className="pub-editor__group">
                    <p className="pub-editor__group-label">{group.label}</p>
                    {group.items.map(({ tab, index }) => (
                        <button
                            type="button"
                            role="tab"
                            aria-selected={index === activeTab}
                            key={`${tab.name}-${index}`}
                            className={`pub-editor__tab${index === activeTab ? " is-active" : ""}`}
                            onClick={() => onChange(index)}
                        >
                            <i className={tab.icon} aria-hidden="true" />
                            <span>{String(tab.name).trim()}</span>
                        </button>
                    ))}
                </div>
            ))}
        </nav>
    );
}

PubSectionNav.propTypes = {
    tabs: PropTypes.array,
    activeTab: PropTypes.number,
    onChange: PropTypes.func,
    groups: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        match: PropTypes.instanceOf(RegExp),
    })),
    ariaLabel: PropTypes.string,
};
